import './filterSheet.scss';
import '@src/components/common/bottomFixedModal/bottomFixedModal.scss';
import { useEffect } from 'react';
import {default as useHooks} from '@src/utils/hooks/useWeddingHallFilterSheet';
import SelectGuaranteeRangeSlider from './SelectGuaranteeRangeSlider';
import { FilterNameKey, TFilterItem, TFilterTag } from '@src/types/weddingHallFilter';
import SelectPriceRangeSlider from './SelectPriceRangeSlider';
import SelectAbleButtons from './sheetItem/SelectAbleButtons';
import { HALL_FILTER_DATA, SLOT_FILTER_DATA } from '@src/utils/weddingHall';
import CheckBoxItems from './sheetItem/CheckBoxItems';
import RadioItems from './sheetItem/RadioItems';
import { numberToKorean } from '@src/utils';
import { createPortal } from 'react-dom';

interface IFilterSheet {
  isShow: boolean;
  items: TFilterItem,
  currentType: FilterNameKey;
  setCurrentType: (type: FilterNameKey) => void;
  tags: TFilterTag[];
  setTags: (tag: TFilterTag[]) => void;
  onClose: () => void;
  slotcnt?:number;
  setFilterChips?:(_) => void;
  prevTags?:TFilterTag[];
}
export const FilterName = {
  HALL_LEVEL: '즉시선점', //실시간 계약, 실시간 예약 여부
  GUARANTEE: '예상하객수',
  RENTAL_PRICE: '대관료',
  MEAL_PRICE: '식대',
  HALL_TYPE:'스타일',
  MEAL_TYPE:'식사종류',
  ENTRANCE_METHOD:'입장방법',
  PARKING:'주차',
  TRAFFIC:'교통',
  VIRGIN_ROAD:'버진로드',
  ETC:'기타',
  WEDDING_DAY:'요일',
  WEDDING_TIME:'시간',
  PARK_TRAFFIC:'교통/주차',
  WEDDING_METHOD:'예식형태' //잔여타입 식사형태 필터에서 분리 -> 동시예식, 분리예식
} as const;
const FilterSheet = ({
    isShow, 
    items,
    currentType,
    setCurrentType,
    tags,
    setTags,
    onClose,
    slotcnt,
    setFilterChips,
    prevTags
}: IFilterSheet) => {
    const isiOS = navigator.userAgent.match(/ipad|iphone/i);
    const filterType = Object.keys(items) as FilterNameKey[];
    
    // 웨딩홀탭, 웨딩홀 검색결과페이지인지 체크
    const isSearchFilter = window.location.pathname.includes('search') || window.location.pathname.includes('/hall');

    // console.log(isiOS && window.location.pathname.includes('result'))

		// Sheet 내부 컨텐츠들 랜더링 해주는 함수
    const ModalContents = () =>{
        switch(currentType){
          case 'HALL_LEVEL':
            return <>
							<RadioItems 
								items={HALL_FILTER_DATA.HALL_LEVEL} 
								onSelect={tag => {
									handleRadioButtonOnSelect(tag);
								}}
								tags={tags} 
							/>
						</>
          case 'GUARANTEE': 
            return <>
							<SelectGuaranteeRangeSlider 
								onRangeChange={(min, max) => {
                  const minMaxName = () => {
                    if(min >= 0 && max === 350) return `예상하객수 ${min}명 이상`
                    if(max === 0) return `예상하객수 ${max}명` 
                    if(min === 350) return `예상하객수 ${min}명 이상`
                    return `예상하객수 ${min}명 ~ ${max}명`
                  }
									const tag = { typeName: currentType, paramName: 'guarantee', value: [min, max], name:minMaxName()};
									handleRangeSliderChange(tag);
								}}
								tags={tags}
							/>
						</>
          case 'RENTAL_PRICE':
            return <>
							<SelectPriceRangeSlider 
								type={currentType}
								onRangeChange={(min, max) => {
									const tag = { typeName: currentType, paramName: 'rentalPrice', value: [min, max], name: `대관료 ${numberToKorean(min)} ~ ${numberToKorean(max)}` };
									handleRangeSliderChange(tag);
								} }
								tags={tags}
							/>
						</>
          case 'MEAL_PRICE':
            return <>
							<SelectPriceRangeSlider 
								type={currentType}
								onRangeChange={(min, max) => {
									const tag = { typeName: currentType, paramName: 'mealPrice', value: [min, max], name: `식대 ${numberToKorean(min)} ~ ${numberToKorean(max)}` };
									handleRangeSliderChange(tag);
								}}
								tags={tags}
							/>
						</>
          case 'HALL_TYPE':
            return <>
							<SelectAbleButtons
								items={isSearchFilter ? HALL_FILTER_DATA.HALL_TYPE : SLOT_FILTER_DATA.HALL_TYPE} 
								onSelect={tag => {
									handleSelectAbleOnSelect(tag);
								}} 
								tags={tags}
							/>
						</>
          case 'MEAL_TYPE':
            return <>
							<CheckBoxItems 
								items={isSearchFilter ? HALL_FILTER_DATA.MEAL_TYPE : SLOT_FILTER_DATA.MEAL_TYPE}
								onSelect={tag => {
									handleSelectAbleOnSelect(tag);
								}} 
								tags={tags}
							/>
						</>
          case 'ENTRANCE_METHOD':
            return <>
							<CheckBoxItems 
								items={HALL_FILTER_DATA.ENTRANCE_METHOD} 
								onSelect={tag => {
									handleCheckBoxOnSelect(tag);
								}}
								tags={tags}
							/>
						</>
          case 'PARKING':
            return <>
							<CheckBoxItems 
								items={HALL_FILTER_DATA.PARKING} 
								onSelect={tag => {
									handleCheckBoxOnSelect(tag);
								}}
								tags={tags} 
							/>
						</>
          case 'TRAFFIC':
            return <>
							<CheckBoxItems 
								items={HALL_FILTER_DATA.TRAFFIC} 
								onSelect={tag => {
									handleCheckBoxOnSelect(tag);
								}}
								tags={tags}
							/>
						</>
          case 'VIRGIN_ROAD':
            return <>
							<CheckBoxItems 
								items={HALL_FILTER_DATA.VIRGIN_ROAD} 
								onSelect={tag => {
									handleCheckBoxOnSelect(tag);
								}}
								tags={tags} 
							/>
						</>
          case 'ETC':
            return <>
							<CheckBoxItems 
								items={HALL_FILTER_DATA.ETC} 
								onSelect={tag => {
									handleCheckBoxOnSelect(tag);
								}}
								tags={tags} 
							/>
						</>
          case 'WEDDING_DAY':
            return <>
							<CheckBoxItems
								items={HALL_FILTER_DATA.WEDDING_DAY} 
								onSelect={tag => {
									handleCheckBoxOnSelect(tag);
								}}
								tags={tags}
							/>
						</>
          case 'WEDDING_TIME':
            return <>
							<SelectAbleButtons
								items={HALL_FILTER_DATA.WEDDING_TIME} 
								onSelect={tag => {
									handleSelectAbleOnSelect(tag);
								}}
								tags={tags}
							/>
						</>
            case 'PARK_TRAFFIC':
              return <>
                <CheckBoxItems 
                  items={isSearchFilter ? HALL_FILTER_DATA.PARK_TRAFFIC : SLOT_FILTER_DATA.PARK_TRAFFIC} 
                  onSelect={tag => {
                    handleCheckBoxOnSelect(tag);
                  }}
                  tags={tags} 
                />
              </>
            case 'WEDDING_METHOD':
              return <>
               	<CheckBoxItems 
                  items={isSearchFilter ? HALL_FILTER_DATA.WEDDING_METHOD : SLOT_FILTER_DATA.WEDDING_METHOD} 
                  // items={HALL_FILTER_DATA.WEDDING_METHOD} 
                  onSelect={tag => {
                    handleCheckBoxOnSelect(tag);
                  }}
                  tags={tags} 
                />
              </>
          default:
            return <div/>
        }
    }
		const handleRangeSliderChange = (tag: TFilterTag) => {
			const newTags = [...tags];
			const existingTagIndex = newTags.findIndex(tag => tag.typeName === currentType);
			if (existingTagIndex >= 0) {
				newTags[existingTagIndex] = tag;
			} else {
				newTags.push(tag);
			}
			setTags(newTags);
		}
		const handleRadioButtonOnSelect = (tag: TFilterTag) => {
			const newTags = [...tags].filter(nTag => nTag.typeName !== tag.typeName);
			newTags.push(tag);
			setTags(newTags);
		}
		// selectAble 과 checkbox는 로직상 똑같음. 합쳐도 될거 같지만 일단 분리 해두자
		const handleSelectAbleOnSelect = (tag: TFilterTag) => {
			const newTags = [...tags];
			const existingTagIndex = newTags.findIndex(nTag => (nTag.value === tag.value && nTag.typeName === tag.typeName));
			if (existingTagIndex >= 0) {
				deleteTag(tag);
			} else {
				addTag(tag);
			}
		}
		const handleCheckBoxOnSelect = (tag: TFilterTag) => {
			const newTags = [...tags];
			const existingTagIndex = newTags.findIndex(nTag => (nTag.value === tag.value && nTag.typeName === tag.typeName));
			if (existingTagIndex >= 0) {
				deleteTag(tag);
			} else {
				addTag(tag);
			}
		}
		const addTag= (tag: TFilterTag) => {
			const newTags = [...tags];
			newTags.push(tag);
			setTags(newTags);
		}
    const deleteTag = (target: TFilterTag) => {
      const newTags = tags.filter(tag => {
        return !(tag.typeName === target.typeName && tag.value === target.value)
      })
      setTags(newTags);
    }


		// tag badge에 표시될 텍스트 랜더링 함수
		const getTagText = (tag: TFilterTag) => {
      // console.log(tag)
			switch(typeof tag.name) {
				case 'string':
					return tag.name;
				case 'object':
					return tag.name.join('~');
			}
			return tag.name 
		}



    const applyFilter = () => {
      if(setFilterChips){
        setFilterChips((prevChips)=>{
          return prevChips.map(chip => {
            const matchedTags = tags.filter(tag => tag.typeName === chip.typeName);
            if (matchedTags.length > 0) {
              const values = matchedTags.map(tag => tag.name);
              chip.value = values.length > 0 ? values[0] + (values.length > 1 ? ` 외 ${values.length - 1}` : '') : values[0];
            } else {
              // 정렬순서와 예식일까지 null로 초기화 되어 조건을 추가하였습니다. 
              if(chip.typeName !== 'SORT_OPTION' && chip.typeName !== 'WEDDING_DATE'){
                chip.value = null;
              }
            }
            return chip;
          });
        })
      }
      onClose();
    }

		useEffect(() => {
			// 시트가 보여질 때 활성화 된 타입으로 가로 스크롤 이동
			if (isShow) {
				const activeElement: HTMLParagraphElement = document.querySelector('.modal-title-scroll .bar.active');
				const PADDING_LEFT = 20;
				if (activeElement) {
					const scrollContainer = document.querySelector('.modal-title-scroll');
					const toLeft = activeElement.offsetLeft - PADDING_LEFT;
					if (scrollContainer) {
						scrollContainer.scrollTo({ left: toLeft });
					}
				}
			}
		}, [isShow]);

		
    return (
		createPortal(
    <div className={`bottom-fixed-modal-wrap product-filter-sheet ${isShow ? 'show' : ''}`}>
        <div className="overlay" 
        onClick={()=>{
          if(prevTags){
            setTags(prevTags)
          }
          onClose()
        }}></div>
        <div className={`bottom-fixed-modal has-transition ${isShow ? 'do-transtion' : ''}`} style={{visibility: 'visible'}}>
            <div className="modal-title-scroll">
                {filterType.map(type => (
                  <p key={`filter-title-scroll-${type}`} className={`bar ${currentType === type ? 'active':''}`} onClick={() => setCurrentType(type)}>
                    <span>{FilterName[type]}</span>
                    {tags.filter(tag => tag.typeName === type).length > 0 && <span className='active-dot'>⦁</span>}
                  </p>
                ))}
            </div>
            <div className={`modal-content filter-contents-wrap ${tags.length > 0 ? 'subtract-tag-height':''}`}>
              <div style={{padding: 20}}>
                <ModalContents/>
              </div>
            </div>
            {tags.length > 0 && 
            <div className='filter-badge-wrap hide-scroll'>
							{tags.map((tag) => (
								<div
									className='badge large badge-gray' 
									onClick={_ => deleteTag(tag)}
									key={`filter-badge-${tag.typeName}-${Array.isArray(tag.value) ? tag.value.join('-') : tag.value}`}
								>
									{/* {typeof tag.value  === 'string' ? tag.value : `${FilterName[tag.typeName]} ${Array.isArray(tag.value) ? tag.value.join(' ~ ') : 'boolean'}`} */}
									{getTagText(tag)}
									<button className="btn btn-auto-height btn-tight btn-transparent ">
										<i className="icon icon-x-circle-gray" />
									</button>
								</div>
							))}        
            </div>}
            {/* ios padding-bottom에 안전마진 값만큼 빼기 */}
            <div className={`filter-sheet-btn-wrap btn-wrap ${isiOS && window.location.pathname.includes('result') ? 'ios-bottom':''}`}>
							<button className={`btn btn-large btn-gray50`} onClick={()=>setTags([])}>
								초기화
							</button>
							<button className={`btn btn-giant btn-red500 btn-full`} onClick={applyFilter}>
								적용
								{slotcnt ?  `(${slotcnt})`: '(0)'}
							</button>
            </div>
        </div>
    </div>,
		document.body));
};
export const useWeddingHallFilterSheet = useHooks;
export default FilterSheet;
// export default createPortal(FilterSheet, document.getElementById('#App'));